import React from "react";
import classNames from "classnames";
import useKeyboardShortcuts from "../../../contexts/KeyboardShortcutContext";
import { useTicketState } from "../../../contexts/ticket-state";
import Styles from "./TopPanel.module.scss";
import Feedback from "../../feedback/Feedback";
import ProductTour from "../tour/Tour";
import HelpWidget from "./widgets/HelpWidget";
import ShortcutsWidget from "./widgets/ShortcutsWidget";
import SearchWidget from "./widgets/SearchWidget";
import CreateNewWidget from "./widgets/CreateNewWidget";
import TopPanelSearch from "./TopPanelSearch";
import CreateTicketRequest from "./widgets/CreateTicketRequest";
import ApprovalsWidget from "./widgets/approvals/ApprovalsWidget";

export enum WidgetType {
    HELP = "HELP",
    CREATE_NEW = "CREATE_NEW",
    SEARCH = "SEARCH",
    SHORTCUTS = "SHORTCUTS",
    FEEDBACK = "FEEDBACK",
    TOUR = "TOUR",
    CREATE_TICKET_REQUEST = "CREATE_TICKET_REQUEST",
    APPROVALS = "APPROVALS",
}

export const WIDGET_MAPPING = {
    [WidgetType.HELP]: HelpWidget,
    [WidgetType.CREATE_NEW]: CreateNewWidget,
    [WidgetType.SEARCH]: SearchWidget,
    [WidgetType.SHORTCUTS]: ShortcutsWidget,
    [WidgetType.FEEDBACK]: Feedback,
    [WidgetType.TOUR]: ProductTour,
    [WidgetType.CREATE_TICKET_REQUEST]: CreateTicketRequest,
    [WidgetType.APPROVALS]: ApprovalsWidget,

};
interface TopPanelProps {
    title: string;
    activeWidgets: WidgetType[];
    metricPathPrefix: string[];
}

export default function TopPanel({ title, activeWidgets, metricPathPrefix }: TopPanelProps) {
    const ticketState = useTicketState();
    const searchState = ticketState.searchState.useSearchContext();

    useKeyboardShortcuts(handler => {
        handler.on({
            shortcut: "/",
            context: "default",
            group: "General",
            description: "Shows the search screen",
            handler: () => {
                ticketState.searchState.showSearch();
            },
        });
        handler.on({
            shortcut: "esc",
            context: "search",
            group: "General",
            description: "Hides the search screen",
            handler: () => ticketState.searchState.hideSearch(),
        });
    });

    if (searchState.isSearching) {
        return <TopPanelSearch />;
    }

    return (
        <div className={classNames(Styles.panel, (searchState.isSearching ? Styles.search : ""))}>
            <div className="flex-grow-1">
                <h3>{title}</h3>
            </div>
            <div className="d-flex gap3-05" data-tour-panel="search-create">
                {
                    activeWidgets.map(widget => {
                        if (widget === WidgetType.TOUR && ticketState.searchState.isSearching) {
                            return null;
                        }

                        const Widget = WIDGET_MAPPING[widget];
                        return <Widget metricPathPrefix={metricPathPrefix} key={widget} />;
                    })
                }
            </div>
        </div>
    );
}
